export const errorTexts = {
  required: 'This field is required',
  password: 'A password should contain at least one lower case character, one uppercase character and one number',
  minlength: 'Minimum length not reached ($MINLENGTH)',
  maxlength: 'Field cant be more than $MAXLENGTH characters long',
  email: 'Invalid email format',
  path: `Should only contain lowercase letters`,
  name: `Please enter your first and last name`,
  phone: `Invalid phone number`,
  website: `Invalid website URL (Don't include the https:// part)`,
  externalUrl: `Invalid website URL`,
  externalUrlOrMailto: `Invalid URL`,
  existingFolderName: 'A folder with this name already exists',
  'custom-domain': 'Invalid custom domain',
  galleryPath: 'Invalid link',
};
